export const FLAGGED_FOR_MANUAL_REVIEW_NOTE = `Flagged for manual review: `;
export const REMOVED_MANUAL_REVIEW_FLAG_NOTE = `Removed flag for manual review: `;
